const RESULT_TRIPS = {
  SPONSORED: 'SPONSORED',
  RECOMMENDED: 'RECOMMENDED',
  SELECTED: 'SELECTED',
} as const;

const TRAIN_SEGMENTS = {
  ALL: 'ALL',
  SOME: 'SOME',
  NONE: 'NONE',
};

type RESULT_TRIP_TYPE = keyof typeof RESULT_TRIPS;
type TRAIN_SEGMENT_TYPE = keyof typeof TRAIN_SEGMENTS;

export type { RESULT_TRIP_TYPE, TRAIN_SEGMENT_TYPE };
export { RESULT_TRIPS, TRAIN_SEGMENTS };
